module.exports = __webpack_public_path__ + "img/Konasoft_Logo_turkiz.a84f7541.png";